(function () {
  var TARGET_PRODUCT_IDS = ['15113446752640', '8775851933926', '7783963951334', '15755000250752', '7433090334950', '4403399786558'];

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  function getVariantImage(variant) {
    var featuredMedia = variant && variant.featured_media;
    var image = variant && variant.featured_image;
    if (!image && featuredMedia) {
      image = featuredMedia.preview_image || featuredMedia;
    }
    var src = image && (image.src || image.url);
    if (!src) return null;
    return {
      src: String(src),
      width: Number(image.width) || 0,
      height: Number(image.height) || 0,
      variantId: variant.id || ''
    };
  }

  function applyVariantImage(variant) {
    var image = getVariantImage(variant);
    var roots = document.querySelectorAll('.pdpv3m-root, .pdpv3d-root');
    if (!roots.length) return false;

    var restoredExistingOverride = false;
    var activeImages = null;

    Array.prototype.forEach.call(roots, function (root) {
      if (!root.__pdpv3BaseImages) {
        var hasStoredBase = root.hasAttribute('data-base-image-fallback');
        root.__pdpv3BaseImages = {
          landscape: hasStoredBase ? (root.dataset.baseImageLandscape || '') : (root.dataset.imageLandscape || ''),
          portrait: hasStoredBase ? (root.dataset.baseImagePortrait || '') : (root.dataset.imagePortrait || ''),
          square: hasStoredBase ? (root.dataset.baseImageSquare || '') : (root.dataset.imageSquare || ''),
          fallback: hasStoredBase ? (root.dataset.baseImageFallback || '') : (root.dataset.imageFallback || '')
        };
        if (!hasStoredBase) {
          root.dataset.baseImageLandscape = root.__pdpv3BaseImages.landscape;
          root.dataset.baseImagePortrait = root.__pdpv3BaseImages.portrait;
          root.dataset.baseImageSquare = root.__pdpv3BaseImages.square;
          root.dataset.baseImageFallback = root.__pdpv3BaseImages.fallback;
        }
      }

      var nextImages = image ? {
        landscape: image.src,
        portrait: image.src,
        square: image.src,
        fallback: image.src
      } : root.__pdpv3BaseImages;

      if (!image && root.dataset.variantImage) restoredExistingOverride = true;
      root.dataset.imageLandscape = nextImages.landscape;
      root.dataset.imagePortrait = nextImages.portrait;
      root.dataset.imageSquare = nextImages.square;
      root.dataset.imageFallback = nextImages.fallback;
      if (image) root.dataset.variantImage = image.src;
      else delete root.dataset.variantImage;
      if (image && image.width > 0 && image.height > 0) {
        root.dataset.variantImageAspectRatio = String(image.width / image.height);
      } else {
        delete root.dataset.variantImageAspectRatio;
      }
      // The theme's variant-media navigation runs after variant:change. Mark
      // the variant handled here so it can leave an active visualiser in place.
      if (variant && variant.id) root.dataset.artworkVariantId = String(variant.id);
      else delete root.dataset.artworkVariantId;
      if (!activeImages) activeImages = nextImages;

      var artImage = root.querySelector('.pdpv3m-art-image, .pdpv3d-art-image');
      var fallbackSrc = nextImages.fallback || nextImages.landscape || nextImages.portrait || nextImages.square;
      if (artImage) {
        if (!artImage.__pdpv3BaseResponsiveImage) {
          artImage.__pdpv3BaseResponsiveImage = {
            srcset: artImage.getAttribute('srcset'),
            sizes: artImage.getAttribute('sizes')
          };
        }

        // A responsive srcset takes precedence over img.src. Remove the
        // Liquid-provided candidates while a connected variant artwork is
        // active, otherwise the browser keeps displaying the original image.
        if (image) {
          artImage.removeAttribute('srcset');
        } else {
          var baseResponsiveImage = artImage.__pdpv3BaseResponsiveImage;
          if (baseResponsiveImage.srcset) artImage.setAttribute('srcset', baseResponsiveImage.srcset);
          else artImage.removeAttribute('srcset');
          if (baseResponsiveImage.sizes) artImage.setAttribute('sizes', baseResponsiveImage.sizes);
          else artImage.removeAttribute('sizes');
        }

        if (fallbackSrc && artImage.getAttribute('src') !== fallbackSrc) artImage.src = fallbackSrc;
      }
    });

    if (!image && !restoredExistingOverride) return false;

    Array.prototype.forEach.call(document.querySelectorAll(
      '.product-main-slide[data-feature="visualiser"] .pdpv3-photoswipe-proxy'
    ), function (proxy) {
      if (!proxy.__pdpv3BaseZoom) {
        proxy.__pdpv3BaseZoom = {
          src: proxy.getAttribute('data-photoswipe-src') || '',
          width: proxy.getAttribute('data-photoswipe-width') || '',
          height: proxy.getAttribute('data-photoswipe-height') || ''
        };
      }
      var zoom = image || proxy.__pdpv3BaseZoom;
      if (zoom.src) proxy.setAttribute('data-photoswipe-src', zoom.src);
      if (zoom.width) proxy.setAttribute('data-photoswipe-width', String(zoom.width));
      if (zoom.height) proxy.setAttribute('data-photoswipe-height', String(zoom.height));
    });

    var activeSrc = image ? image.src : (activeImages.fallback || activeImages.landscape || activeImages.portrait || activeImages.square);
    if (!activeSrc) return false;
    var thumbSrc = activeImages.landscape || activeSrc;
    var visualiserThumb = document.querySelector('.custom-product__thumb-item--visualiser .product__thumb');
    if (visualiserThumb) {
      var thumbArt = visualiserThumb.querySelector('.custom-product-landscape-img-thumb');
      if (!thumbArt) {
        thumbArt = document.createElement('img');
        thumbArt.className = 'custom-product-landscape-img-thumb';
        thumbArt.alt = 'Visualiser thumbnail artwork';
        visualiserThumb.appendChild(thumbArt);
      }
      if (thumbArt.getAttribute('src') !== thumbSrc) thumbArt.setAttribute('src', thumbSrc);
    }
    Array.prototype.forEach.call(document.querySelectorAll('.pdpv3-target-thumb-art'), function (thumbArt) {
      if (thumbArt.getAttribute('src') !== thumbSrc) thumbArt.setAttribute('src', thumbSrc);
    });

    var preloader = new Image();
    preloader.decoding = 'async';
    preloader.src = activeSrc;
    document.dispatchEvent(new CustomEvent('pdpv3:artwork-change', {
      detail: {
        src: activeSrc,
        images: activeImages,
        width: image ? image.width : 0,
        height: image ? image.height : 0,
        variantId: variant && variant.id || ''
      }
    }));
    return true;
  }

  function getInitialVariant() {
    var productData = window.__THEME_PRODUCT_DATA__;
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    if (!variants.length) return null;

    var variantId = '';
    try {
      variantId = new URLSearchParams(window.location.search || '').get('variant') || '';
    } catch (error) {}

    if (!variantId) {
      var masterSelect = document.querySelector('form[action*="/cart/add"] [name="id"], select[name="id"]');
      variantId = masterSelect ? masterSelect.value : '';
    }

    for (var i = 0; i < variants.length; i += 1) {
      if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    return variants[0] || null;
  }

  onReady(function () {
    if (
      !window.__THEME_PRODUCT_DATA__ ||
      TARGET_PRODUCT_IDS.indexOf(String(window.__THEME_PRODUCT_DATA__.productId || '')) === -1
    ) return;

    // Variants without an explicitly assigned image retain the Liquid-provided
    // visualiser artwork and orientation fallbacks.
    applyVariantImage(getInitialVariant());
    document.addEventListener('variant:change', function (event) {
      applyVariantImage(event && event.detail && event.detail.variant);
    });
  });
})();
